import React from 'react';
export function Newsletter() {
  return <section className="w-full relative py-24 bg-charcoal overflow-hidden" data-id="element-138">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center opacity-30 grayscale" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=2000&q=80)'
    }} data-id="element-139" />
      <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-charcoal/90 to-transparent" data-id="element-140" />

      <div className="relative max-w-[1400px] mx-auto px-4 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-12" data-id="element-141">
        <div className="md:w-1/2" data-id="element-142">
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-white uppercase italic mb-4 leading-none tracking-tight" data-id="element-143">
            Join the <span className="text-primary" data-id="element-144">Pro One</span> Team
          </h2>
          <p className="text-gray-400 text-lg max-w-md font-sans border-l-2 border-primary pl-4" data-id="element-145">
            Subscribe to our newsletter for exclusive deals, new product drops,
            and off-road tips delivered straight to your inbox.
          </p>
        </div>

        <div className="w-full md:w-1/2 max-w-md" data-id="element-146">
          <form className="flex flex-col sm:flex-row gap-0" data-id="element-147">
            <input type="email" placeholder="Enter your email address" className="flex-grow px-6 py-4 bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-primary focus:bg-white/10 transition-all font-sans" data-id="element-148" />
            <button type="submit" className="px-8 py-4 bg-primary text-white font-heading font-bold text-xl uppercase italic tracking-wide hover:bg-white hover:text-charcoal transition-colors whitespace-nowrap" data-id="element-149">
              Subscribe
            </button>
          </form>
          <p className="mt-4 text-xs text-gray-500 font-sans" data-id="element-150">
            By subscribing you agree to our Privacy Policy. Unsubscribe at any
            time.
          </p>
        </div>
      </div>
    </section>;
}